import React, { memo } from "react";
import styled from "styled-components";
import { BlobBlock, Title, AsideIcon } from "./index-styled";
import StarIcon from "_c/icon/Star";
import AchievesList from "_c/modules/profile/common/achieves-list";
import PT from "prop-types";

const EnhancedTitle = styled(Title)`
  margin-bottom: 30px;
  @media (max-width: 991px) {
    margin-bottom: 20px;
  }
  @media (max-width: 991px) {
    margin-bottom: 30px;
  }
`;
const EnhancedBlock = styled(BlobBlock)`
  height: auto;
  max-height: auto;
`;
const AchievesBlock = memo((props) => {
  return (
    <EnhancedBlock>
      <AsideIcon>
        <StarIcon width="19" color="var(--font-color-emp)" />
      </AsideIcon>
      <EnhancedTitle>{props.t("common:achieves")}</EnhancedTitle>
      <AchievesList
        t={props.t}
        pageType="master"
        isOwner={props.isOwner}
        achieves={props.achieves}
      />
    </EnhancedBlock>
  );
});
AchievesBlock.propTypes = {
  isOwner: PT.bool,
  achieves: PT.array,

  t: PT.func.isRequired,
};

export default AchievesBlock;
